import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextBold"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.6875 18.75H6.75V5.25H13.125C14.6597 5.25009 16.0545 6.14187 16.6986 7.53484C17.3428 8.92781 17.1189 10.5681 16.125 11.7375C17.4279 12.7795 17.9327 14.5295 17.385 16.1053C16.8372 17.6812 15.3558 18.7408 13.6875 18.75ZM9 16.5H13.6725C14.2754 16.5 14.8325 16.1784 15.1339 15.6562C15.4354 15.1341 15.4354 14.4909 15.1339 13.9688C14.8325 13.4466 14.2754 13.125 13.6725 13.125H9V16.5ZM9 10.875H13.125C13.7279 10.875 14.285 10.5534 14.5864 10.0312C14.8879 9.50914 14.8879 8.86586 14.5864 8.34375C14.285 7.82164 13.7279 7.5 13.125 7.5H9V10.875Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextBold.vue"]]);
